import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackSubmitReturnRequestParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/order/trackSubmitReturnRequest";

const useTrackSubmitReturnRequest = (
    parameters: TrackSubmitReturnRequestParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.submitReturnRequest, parameters, options);
};

export default useTrackSubmitReturnRequest;
